import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './containers/Home';
import About from './containers/Pages/About';
import Solutions from './containers/Pages/Solutions';
import Contact from './containers/Pages/Contact';
import Consultation from './containers/Pages/Consultation';
import SecureShield from './containers/Pages/SecureShield';
import PrivacyPolicy from './containers/Pages/PrivacyPolicy';
import TermsConditions from './containers/Pages/TermsConditions';
import Sitemap from './containers/Pages/Sitemap';


function App() {
  return (
    <div className="App">
      <Router>


        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/about' element={<About />} />
          <Route exact path='/solutions' element={<Solutions />} />
          <Route exact path='/contact' element={<Contact />} />
          <Route exact path='/consultation' element={<Consultation />} />
          <Route exact path='/bluelotus-secureshield' element={<SecureShield />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route exact path='/terms-conditions' element={<TermsConditions />} />
          <Route exact path='/sitemap' element={<Sitemap />} />


        </Routes>
      </Router>
    </div>
  );
}

export default App;
